// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"7d2c9ae0","359":"66a4370f","753":"51ef2f35","907":"77868bb1","923":"ee562536"}[chunkId] + ".chunk.js";
};